<template>
    <div class="filter-bar ui basic segment grid">
        <div class="simple-search-container">
            <input type="text" v-model="filterText" class="form-control" @keyup.enter="doFilter" :placeholder="placeholder">
            <transition name="btn-fade">
                <button class="btn btn-outline-primary simple-search-button" v-if="filterText" @click="resetFilter">
                    Reset
                </button>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        debounce: {
            type: Number,
            default: 500
        },
        useLocalEmit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            filterText: ''
        }
    },
    created () {
        this.emitBouncedFilterResults = _.debounce( function() {
            if (this.useLocalEmit) {
                this.$emit('filter-set', this.filterText);
            } else {
                this.$events.fire('filter-set', this.filterText);
            }
        }, this.debounce);
    },
    methods: {
        doFilter() {
            this.emitBouncedFilterResults();
        },
        resetFilter() {
            this.filterText = '';
            this.$events.fire('filter-reset');
        }
    },
    watch: {
        filterText: function(val) {
            this.emitBouncedFilterResults();
        }
    }
}
</script>

 <style scoped lang="scss">
    .simple-search-container{
        position: relative;
        max-width: 300px;
    }
    .simple-search-button{
        position: absolute;
        right: 0;
        top: 0;
    }
    .btn-fade-enter-active, .btn-fade-leave-active {
        transition: opacity .5s;
    }
    .btn-fade-enter, .btn-fade-leave-to{
        transition: opacity .5s;
        opacity: 0;
    }
</style>
